import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";

/**
 * autoReset to automatically call static() on completion
 */
export function HighlightSymbolsCommand(symbols: SymbolComponent[], autoReset?: boolean): Contract<void> {
    const winningSymbolHighlightMethods = symbols.map((symbol) => highlightSymbol(symbol, autoReset));

    return new Parallel(winningSymbolHighlightMethods);
}

function highlightSymbol(symbol: SymbolComponent, autoReset?: boolean) {
    symbol.static();
    return () => new Contract((resolve) => {
        symbol.highlight().then(() => {
            if (autoReset) {
                symbol.static();
            }
            resolve();
        });
    });
}
